
/**
 * Hook to generate the profile path based on username_slug or id
 */
export const useProfilePath = ({ 
  id, 
  username_slug 
}: { 
  id: string; 
  username_slug?: string | null 
}) => {
  // Generate profile path - use username_slug if available, otherwise use ID
  const profilePath = username_slug ? `/u/${username_slug}` : `/profile/${id}`;
  
  return {
    profilePath
  };
};
